/** Canonical business identity displayed on every website route and SMS disclosure.
 * Verify this legal entity/address matches the business records and Telnyx registration.
 */
const COMPANY = {
  brand: 'Bitnex Freight LLC',
  legalName: 'Bitnex Freight LLC',
  legalDisclaimer: 'Bitnex Freight LLC — 4560 Rosswood Dr, Memphis, TN 38128',
  tagline: 'Moving Freight. Supporting Drivers.',
  website: 'https://bitnexfreight.com',
  domainDisplay: 'bitnexfreight.com',
  phone: 'tel:+12109724717',
  phoneDisplay: '(210) 972-4717',
  phoneE164: '+12109724717',
  email: 'mailto:info@bitnexfreight.com',
  emailDisplay: 'info@bitnexfreight.com',
  hq: { label: 'Business address', line1: '4560 Rosswood Dr', line2: 'Memphis, TN 38128' },
  hours: 'Business inquiries by email',
  responseTime: 'within one business day',
  social: { facebook: '' },
  sms: { programName: 'Bitnex Freight LLC SMS Updates', frequency: 'Message frequency varies', marketingFrequency: 'up to 4 marketing messages per month' },
  legalUpdated: 'November 2026',
  copyrightStart: 2026,
};
export const ROUTES = {
  home: '/', services: '/services', trailers: '/trailers', about: '/about', contact: '/contact', signup: '/sign-up',
  smsOptIn: '/sms-opt-in', privacy: '/privacy-policy', terms: '/terms-and-conditions', smsTerms: '/sms-terms',
  signin: '/sign-in', admin: '/admin',
};
export default COMPANY;
